import * as React from 'react';

interface DriverJobsDepartOfficeProps {
    truckId: number;
    departureCheck: DepartureCheck;
    saveDisabled: boolean;
    updateDetails(arrivalCheck: DepartureCheck): void;
    save(): void;
}

interface DriverJobsDepartOffice {
    loading: boolean;
    errors: any;
}

interface DepartureCheck {
    id: number;
    gearCheck: number;
    teamMemberPpe: number;
}

export default class DriverJobsDepartOfficeData extends React.Component<DriverJobsDepartOfficeProps, DriverJobsDepartOffice> {
    constructor(props: DriverJobsDepartOfficeProps) {
        super(props);

        this.state = {
            loading: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let departureCheck = this.props.departureCheck;
        let change: any = {};
        change = departureCheck;
        change[e.target.name] = e.target.value * 1;
        this.setState({ errors: errors });
        this.props.updateDetails(departureCheck);
    }

    validate = () => {
        let fields = this.props.departureCheck;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.gearCheck || fields.gearCheck < 1) {
            formIsValid = false;
            errors["gearCheck"] = "You MUST complete gear check before departing!";
        }

        if (!fields.teamMemberPpe || fields.teamMemberPpe < 0) {
            formIsValid = false;
            errors["teamMemberPpe"] = "Team Members PPE is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var departureCheck = this.props.departureCheck;

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <h4>Departure Checks</h4>
                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="gearCheck">
                        <span className="label-mobile--inline margin5">Have you completed the gear check?</span>
                        <input type="radio" id="yes" name="gearCheck" value={1} checked={departureCheck.gearCheck === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="gearCheck" value={0} checked={departureCheck.gearCheck === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["gearCheck"] ? "label errors" : "hidden"}>{this.state.errors["gearCheck"]}</span>

                    <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="teamMemberPpe">
                        <span className="label-mobile--inline margin5">Are all team members wearing appropriate PPE, i.e. Hard Hat, Hi Vis Clothing, Boots etc?</span>
                        <input type="radio" id="yes" name="teamMemberPpe" value={1} checked={departureCheck.teamMemberPpe === 1} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                        <input type="radio" id="no" name="teamMemberPpe" value={0} checked={departureCheck.teamMemberPpe === 0} onChange={(e) => this.handleChange(e)}></input>
                        <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                    </label>
                    <span className={this.state.errors["teamMemberPpe"] ? "label errors" : "hidden"}>{this.state.errors["teamMemberPpe"]}</span>
                    <span className={departureCheck.teamMemberPpe === 0 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                    <div className="defaultbutton__container--right marginTop10">
                        <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (this.props.saveDisabled ? " mobile-image-button--disabled" : "" )} onClick={(e) => this.save(e)}></i>
                    </div>

                </div>
            </div>
        );

    }
}


